import React from "react";
import "./preloader.css";

const Preloader = () => {
  return (
    <div id="preloader">
      <div className="preloader-overlay">
        <div className="preloader"></div>
      </div>
    </div>
  );
};

export default Preloader;
